module.exports = new function gameReleaseSlider()
{
    const Flickity = require('flickity');
    const sliders = document.querySelectorAll('[data-js="game-slider"]');

    if ( sliders.length > 0 ) {
        for ( let i = 0; i < sliders.length; i++ ) {
            let flkty = new Flickity( sliders[i], {
                cellSelector: '.upcoming-games__slider-slide',
                wrapAround: false,
                prevNextButtons: true,
                pageDots: false,
                cellAlign: 'left',
                contain: true,
                selectedAttraction: 0.05,
                friction: 0.40
            });

            window.addEventListener( 'load', function() { flkty.resize() });
        }
    }
}